import { getRequest, postRequest } from 'api/apiUtils'
import { IS_PRODUCTION } from 'utils/helperConfig'
import { all, call, put, takeLatest } from 'redux-saga/effects'
import UserActionTypes from '../user/user-types'
import { startGetReferrals, successGetReferrals, successGetReferralsStatus, successPostReferralsTraffic } from './referrals-actions'
import ReferralsActionTypes from './referrals-types'

function* getReferrals() {
    try {
        const { data } = yield getRequest('/referrals')
        yield put(successGetReferrals(data))
    } catch (err) {
        if (!IS_PRODUCTION) {
            console.log('failureGetReferrals')
        }
    }
}
export function* onGetReferrals() {
    yield takeLatest(ReferralsActionTypes.START_GET_REFERRALS, getReferrals)
}

function* fetchData() {
    yield put(startGetReferrals())
}

export function* onSignSuccess() {
    yield takeLatest(UserActionTypes.SIGN_IN_SUCCESS, fetchData)
}

function* getReferralsStatus({ payload: id }) {
    try {
        const { data } = yield getRequest(`/referrals/${id}/program`)
        yield put(successGetReferralsStatus(data))
    } catch (err) {
        if (!IS_PRODUCTION) {
            console.log('failureGetReferralsStatus')
        }
    }
}

export function* onGetReferralsStatus() {
    yield takeLatest(ReferralsActionTypes.START_GET_REFERRALS_STATUS, getReferralsStatus)
}

function* postReferralsTraffic({ payload: { profileId, deviceId } }) {
    try {
        yield postRequest('/referrals/traffic-analytics', { identityProfileUniqueId: profileId, deviceId })
        yield put(successPostReferralsTraffic())
    } catch (err) {
        if (!IS_PRODUCTION) {
            console.log('failurePostReferralsTraffic')
        }
    }
}

export function* onPostReferralsTraffic() {
    yield takeLatest(ReferralsActionTypes.START_POST_REFERRALS_TRAFFIC, postReferralsTraffic)
}

export function* referralsSagas() {
    yield all([call(onGetReferrals), call(onSignSuccess), call(onGetReferralsStatus), call(onPostReferralsTraffic)])
}
